import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import darkLogo from '../../assets/images/logo-dark.webp';
import lightLogo from '../../assets/images/logo-light.webp';

const useStyles = makeStyles((theme) => ({
  logoContainer: {
    maxWidth: 200,
    width: '100%',
    aspectRatio: '4 / 1',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      maxWidth: 150,
    },
  },
  logoImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
    transition: 'filter 0.3s ease',
    '&:hover': {
      filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))',
    },
  },
}));

export const Logo = () => {
  const classes = useStyles();
  const theme = useTheme();
  const logoSrc = theme.palette.mode === 'dark' ? darkLogo : lightLogo;

  return (
    <div className={classes.logoContainer}>
      <img 
        src={logoSrc} 
        alt="Site Logo" 
        className={classes.logoImage}
        loading="eager" // Important for logo to load immediately
      />
    </div>
  );
};